var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "report_bar",
          attrs: { flat: "", dense: "", color: "blue-grey lighten-5" }
        },
        [
          _c("v-toolbar-title", [_vm._v("Packing")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.packsReport && _vm.packsReport.length == 0 && _vm.isToday
            ? _c(
                "v-btn",
                {
                  staticClass: "blue--text",
                  attrs: { icon: "", color: "accent-2" },
                  on: {
                    click: function($event) {
                      return _vm.logInfo()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-clipboard-edit-outline")])],
                1
              )
            : _vm.packsReport &&
              _vm.packsReport.length == 1 && _vm.activePackers.length > 0 &&
              _vm.isToday
            ? _c(
                "v-btn",
                {
                  staticClass: "blue--text",
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.editReport(_vm.packsReport[0])
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-clipboard-edit")])],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "8" } },
            [
              _vm.packJobs
                ? _c("v-data-iterator", {
                    attrs: {
                      items: _vm.dailypacks.packs,
                      "hide-default-footer": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var items = ref.items
                            return [
                              _c(
                                "v-row",
                                _vm._l(items, function(item) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: item.id,
                                      attrs: {
                                        cols: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _c(
                                            "v-card-title",
                                            {
                                              staticClass:
                                                "subheading font-weight-bold",
                                              attrs: {
                                                flat: "",
                                                dense: "",
                                                color: "blue-grey lighten-5"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(item.name) +
                                                  "\n\n                "
                                              ),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              item.packs.length <
                                                _vm.onlineRigs.length &&
                                              _vm.isToday
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "blue--text",
                                                      attrs: {
                                                        icon: "",
                                                        small: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.addJobs(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("mdi-plus")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-divider"),
                                          _vm._v(" "),
                                          _c(
                                            "v-data-table",
                                            {
                                              attrs: {
                                                "hide-default-footer": "",
                                                headers: _vm.headers,
                                                items: item.packs,
                                                "items-per-page": 10,
                                                flat: ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "item.actions",
                                                    fn: function(ref) {
                                                      var item = ref.item
                                                      return [
                                                        _vm.isToday
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "red--text",
                                                                attrs: {
                                                                  icon: "",
                                                                  small: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.undo(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      center: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-undo-variant"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "body.append" },
                                                [
                                                  _c(
                                                    "tr",
                                                    {
                                                      staticClass: "blue--text"
                                                    },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass: "title"
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass: "title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.sum(
                                                                item.packs,
                                                                "jobs"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass: "title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.sum(
                                                                item.packs,
                                                                "cutaways"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass: "title"
                                                        },
                                                        [_vm._v(" ")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1017518392
                    )
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _vm.packsReport && _vm.packsReport.length > 0
                ? _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-content", [
                            _vm._v("Total Pack Jobs")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            { staticClass: "align-end" },
                            [
                              _vm._v(
                                "\n\n                      " +
                                  _vm._s(
                                    _vm.packsReport
                                      ? _vm.packsReport[0].jobs
                                      : 0
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-content", [
                            _vm._v("Completed Jumps")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            { staticClass: "align-end" },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.totalJumps ? _vm.totalJumps.Complete : 0
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-content", [_vm._v("Discrepancy")]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            { staticClass: "align-end" },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.packsReport
                                      ? _vm.packsReport[0].discrepancy
                                      : 0
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-content", [
                            _vm._v(
                              "\n                  Reason \n\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            { staticClass: "align-end" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.packsReport
                                      ? _vm.packsReport[0].reason
                                      : " "
                                  ) +
                                  "\n                      "
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editReason(_vm.packsReport[0])
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-pencil")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.dialog = false
            }
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.saveReport($event)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _vm.rigIDsByPacker.length == 0
                        ? _c("v-select", {
                            attrs: {
                              items: _vm.activePackers,
                              "item-text": "name",
                              "item-value": "id",
                              placeholder: "Packer",
                              "hide-no-data": "",
                              rules: _vm.packerRules
                            },
                            model: {
                              value: _vm.editedItem.packer_id,
                              callback: function($$v) {
                                _vm.$set(_vm.editedItem, "packer_id", $$v)
                              },
                              expression: "editedItem.packer_id"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.editedItem.packedRigs, function(p, index) {
                        return _c(
                          "fieldset",
                          { staticClass: "inline-form input-3" },
                          [
                            _c("v-checkbox", {
                              attrs: { label: p.rig },
                              model: {
                                value: p.sel,
                                callback: function($$v) {
                                  _vm.$set(p, "sel", $$v)
                                },
                                expression: "p.sel"
                              }
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                disabled: !p.sel,
                                rules: !p.sel ? [] : _vm.reqNumber,
                                label: "Pack Jobs",
                                type: "number"
                              },
                              model: {
                                value: p.jobs,
                                callback: function($$v) {
                                  _vm.$set(p, "jobs", _vm._n($$v))
                                },
                                expression: "p.jobs"
                              }
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                disabled: !p.sel,
                                label: "Cutaways",
                                type: "number"
                              },
                              model: {
                                value: p.cutaways,
                                callback: function($$v) {
                                  _vm.$set(p, "cutaways", _vm._n($$v))
                                },
                                expression: "p.cutaways"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "fieldset",
                        { staticClass: "inline-form input-3" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              readonly: "",
                              label: "Completed Jumps",
                              type: "number"
                            },
                            model: {
                              value: _vm.totalJumps.Complete,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.totalJumps,
                                  "Complete",
                                  _vm._n($$v)
                                )
                              },
                              expression: "totalJumps.Complete"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              readonly: "",
                              label: "Total Jobs",
                              type: "number"
                            },
                            model: {
                              value: _vm.totalJobs,
                              callback: function($$v) {
                                _vm.totalJobs = _vm._n($$v)
                              },
                              expression: "totalJobs"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              label: "Discrepancy",
                              readonly: "",
                              type: "number"
                            },
                            model: {
                              value: _vm.discrepancy,
                              callback: function($$v) {
                                _vm.discrepancy = _vm._n($$v)
                              },
                              expression: "discrepancy"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.saving,
                            color: "blue darken-1",
                            text: ""
                          },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.saving,
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }